<div class="format-container pt-2">
  <div class="row mx-0">
    <div class="col-12 col-sm-12 col-md-12 col-sm-12 p-2">
      <div class="row align-items-center new-tag-container">
        <h3 class="text-center sub-header">Create New Tag:</h3>
        <div class="flex">
          <span class="title">Shape: </span>
          <div class="shape-container">
            <div *ngFor="let shape of tagShapes" class="shape">
              <div
                style="cursor: pointer"
                (click)="selectShape(shape)"
                [ngClass]="{ 'shape-box': selectedShape.id == shape.id }"
                *ngIf="shape?.asset; else noShape"
                [title]="shape.name"
                [innerHTML]="sanitizeSVGString(shape.asset)"></div>
              <ng-template #noShape>
                <div style="cursor: pointer" (click)="selectShape({})" [title]="shape.name">
                  {{ shape.name }}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="flex">
          <span class="title">Color:</span>
          <input (input)="selectColor($event.target.value)" type="color" />
        </div>
        <!-- Label -->
        <div class="flex">
          <span class="title">Label: </span>
          <div class="input-group">
            <input
              #newTag
              type="text"
              class="form-control"
              placeholder="OSHA30"
              aria-label=""
              aria-describedby="basic-addon2" />
            <div class="input-group-append">
              <a
                (click)="addNewTag(newTag)"
                id="basic-addon2"
                href="javascript:void(0);"
                class="btn btn-primary add-tag-btn">
                <img src="/assets/images/icon/plus.svg" />Add Tag
              </a>
            </div>
          </div>
        </div>
        <!-- Eraser -->
        <div class="flex shape-container">
          <span class="title">Eraser: </span>
          <img
            style="cursor: pointer"
            (click)="selectShape({ name: 'eraser', asset: '/assets/images/icon/eraser.svg' })"
            [ngClass]="{ 'shape-box': selectedShape.name == 'eraser' }"
            src="/assets/images/icon/eraser.svg" />
        </div>
        <!-- Info -->
        <div class="flex">
          <a
            data-placement="bottom"
            class="tooltip-icon"
            data-toggle="tooltip"
            data-html="true"
            title="Tagging can be used for Job & Employee cards"
            ><img src="/assets/images/icon/info.svg"
          /></a>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-2 py-3">
    <div class="row align-items-center select-tag-container">
      <h3 class="text-center sub-header mr-3">Select Tag:</h3>
      <div>
        <ul class="list-group">
          <li *ngFor="let tag of tags" class="list-group-item" [draggable] [dragData]="tag" [dragEnabled]="true">
            <app-job-board-tags
              [removable]="true"
              (delete)="deleteTag($event)"
              [tag]="tag"
              [tagShape]="tag?.shape"></app-job-board-tags>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
